var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.patient && _vm.user)?_c('v-layout',{staticClass:"patient-page",attrs:{"justify-start":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('threshold-settings',{staticClass:"mb-4"})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }